<template>
  <v-form v-model="valid" ref="mainForm">
    <data-iterator
      :list="sas.activites"
      add-new-text="Ajouter une activité"
      :live="{ endpoint: 'sas-activites-accreditations', sasId: sas.id }"
      :icon="$getIcon('job')"
      :valids="valids"
      ref="dataIterator"
      hidePoints
    >
      <template v-slot:show-mode="{ item }">
        <h3>{{ item.titreDeLActivite }}</h3>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="activite_titre" v-model="item.titreDeLActivite" :live="liveSasActivite(24904, item)" :maxLength="250" />
        <DatePickerLive
          code="activite_date_debut"
          v-model="item.dateDeDebut"
          :live="liveSasActivite(24902, item)"
          :minValue="serverDate()"
          :maxValue="serverDatePlusNMonths(12)"
        />
        <DatePickerLive
          code="activite_date_fin"
          v-model="item.dateDeFin"
          :live="liveSasActivite(24911, item)"
          :minValue="item.dateDeDebut"
          :maxValue="getMaxDate(item.dateDeDebut)"
        />
        <TimeLive
          :opq-if="!estMidiScientifique"
          :maxHour="6"
          :minutesInterval="15"
          code="activite_duree"
          v-model="item.dureeEnHeures"
          :live="liveSasActivite(24903, item)"
        />
        <TextFieldLive code="activite_objectif1" v-model="item.objectif1" :live="liveSasActivite(24906, item)" :maxLength="500" />
        <TextFieldLive code="activite_objectif2" v-model="item.objectif2" :live="liveSasActivite(24907, item)" :maxLength="500" />
        <TextFieldLive code="activite_objectif3" v-model="item.objectif3" :live="liveSasActivite(24908, item)" :maxLength="500" />
        <TextFieldLive code="activite_objectif4" v-model="item.objectif4" :live="liveSasActivite(24909, item)" :maxLength="500" />
        <TextFieldLive code="activite_objectif5" v-model="item.objectif5" :live="liveSasActivite(24905, item)" :maxLength="500" />
        <FileInput
          :opq-if="!estOui(sasAccreditation?.cccepPourUneFormationEnFrancais) && !estMidiScientifique"
          code="activite_contenu_formation"
          :file="item.contenuActivite"
          :live="liveSasActivite(24910, item)"
          :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
          :optionelConditionnel="estCongres"
        />
        <FileInput
          :opq-if="estMidiScientifique && !estOui(sasAccreditation?.cccepPourUneFormationEnFrancais)"
          code="sommaire_activite"
          :file="item.sommaireActivite"
          :live="liveSasActivite(24912, item)"
          :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
        />
        <TextFieldLive
          :opq-if="estAutoApprentissage && !estOui(sasAccreditation?.cccepPourUneFormationEnFrancais)"
          code="lien_contenu_audiovideo"
          v-model="item.telechargementDuContenuAudioOuVideo"
          :live="liveSasActivite(24913, item)"
          :maxLength="1000"
        />
        <FileInput
          :opq-if="estAutoApprentissage && !estOui(sasAccreditation?.cccepPourUneFormationEnFrancais)"
          code="activite_evaluation_certificative"
          :file="item.evaluationCertificative"
          :live="liveSasActivite(24915, item)"
          :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
        />
        <FileInput
          :opq-if="estMidiScientifique && !estOui(sasAccreditation?.cccepPourUneFormationEnFrancais)"
          code="activite_exemple_contenu1"
          :file="item.exemple1DeContenuMidiScientifique"
          :live="liveSasActivite(24916, item)"
          :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
        />
        <FileInput
          :opq-if="estMidiScientifique && !estOui(sasAccreditation?.cccepPourUneFormationEnFrancais)"
          code="activite_exemple_contenu2"
          :file="item.exemple2DeContenuMidiScientifique"
          :live="liveSasActivite(24917, item)"
          :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
        />
        <FileInput
          :opq-if="estMidiScientifique && !estOui(sasAccreditation?.cccepPourUneFormationEnFrancais)"
          code="activite_exemple_contenu3"
          :file="item.exemple3DeContenuMidiScientifique"
          :live="liveSasActivite(24918, item)"
          :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
        />

        <FileInput
          code="activite_document1"
          :file="item.documentActivite1"
          :live="liveSasActivite(24919, item)"
          :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
        />
        <FileInput
          code="activite_document2"
          :file="item.documentActivite2"
          :live="liveSasActivite(24920, item)"
          :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
        />
      </template>
    </data-iterator>
    <v-checkbox class="list_counter_validator my-2 ml-6 p-0 alert_style" :rules="ruleActivite" :input-value="valueRuleActivite" />
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import infosGeneralesAccreditation from "@/components/Formulaires/DemandeAccreditation/mixins/infosGeneralesAccreditation"
import { mapGetters } from "vuex"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers, infosGeneralesAccreditation],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasActivite(cle, item) {
      return { endpoint: "sas-activites-accreditations", cle: cle, fileId: item.id }
    },
    getMaxDate(date) {
      if (date === null) {
        return null
      }
      return this.datePlusNMonths(date, 12)
    }
  },
  computed: {
    ...mapGetters(["ressourcesByCode"]),
    valueRuleActivite() {
      if (!this.estCongres) {
        return this.sas.activites.length === 1
      }
      return true
    },
    ruleActivite() {
      if (this.estCongres) {
        return []
      }

      return [() => this.sas.activites.length <= 1 || this.ressourcesByCode("alerte_regle_plusieurs_activites")]
    }
  }
}
</script>

<style>
</style>